import { render, staticRenderFns } from "./SongLyrics.vue?vue&type=template&id=41b83ef0"
import script from "./SongLyrics.vue?vue&type=script&lang=js"
export * from "./SongLyrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports